import { useEffect, useMemo } from "react"
import { useNavigate, useOutletContext, useParams } from "react-router-dom"

import type { DeviceDashboardOutletContext } from "types/dashboard.types"

import { getDeviceAmbientConfig } from "helpers/utils/deviceAmbient"
import DeviceDashboard from "widgets/device/DeviceDashboard"
import { BodyContainer } from "widgets/styled/containers"

function DeviceAmbient() {
  const navigate = useNavigate()
  const { orgId, id } = useParams()
  const { device } = useOutletContext<DeviceDashboardOutletContext>()

  const config = useMemo(() => getDeviceAmbientConfig(device), [device])

  useEffect(() => {
    if (device && !config) {
      navigate(`/orgs/${orgId}/devices/${id}`, { replace: true })
    }
  }, [device, config, navigate, orgId, id])

  if (!config) {
    return null
  }

  return (
    <BodyContainer disableGutters maxWidth="xl">
      <DeviceDashboard device={device} config={config} />
    </BodyContainer>
  )
}

export default DeviceAmbient
